//import '@reach/alert-dialog/styles.css';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaArrowRight } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { Address, Location, LocationType } from '../../../../@posturinn/client-react';
import { setActiveModal } from '../../../../actions/modalActions';
import { CONFIRMATION, DELIVERY_OPTION_MODAL } from '../../../../constants/documentTypes/modals/modals';
import useLocations from '../../../../hooks/useLocations';
import { ReactComponent as IconBin } from '../../../../icons/bin.svg';
import { ReactComponent as IconPakkaport } from '../../../../icons/delivery_option_pakkaport.svg';
import { ReactComponent as IconPostbox } from '../../../../icons/delivery_option_postbox.svg';
import { ReactComponent as IconPostoffice } from '../../../../icons/delivery_option_postoffice.svg';
import { ReactComponent as IconPencil } from '../../../../icons/pencil.svg';
import IUserProfileReducer from '../../../../interfaces/reducers/userProfileReducer';
import { IStore } from '../../../../reducers';
import { Column, Columns } from '../../../base/grid';
import MyShipmentsTileLoader from '../../../base/misc/myShipmentsTileLoader';
import { A, H4, H5, H6, P } from '../../../base/typography';
import * as StyledSettings from '../settings.styles';
import * as StyledPreferredDeliveryMethod from './preferredDeliveryMethod.styles';

interface Props {}

const PreferredDeliveryMethod: FC<Props> = () => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<any>();
	const userProfileReducer: IUserProfileReducer = useSelector<IStore, IUserProfileReducer>(
		store => store.userProfileReducer
	);
	const { userProfile } = userProfileReducer;
	const [deliveryOption, setDeliveryOption] = useState(new Location());
	const [deliveryOptionAddress, setDeliveryOptionAddress] = useState(new Address());
	const { locations, locationsLoading } = useLocations();

	useEffect(() => {
		// eslint-disable-next-line no-unused-expressions
		locations?.map(location => {
			if (location.id === userProfile.preferredDeliveryMethodLocationId) {
				setDeliveryOption(location);
				setDeliveryOptionAddress(location.address);
			}
		});
	}, [locations, userProfile]);

	return (
		<>
			<StyledSettings.HeaderSub>
				<H4>{t('page-settings.deliveryOptions')}</H4>
				<H5>{t('page-settings.deliveryOptionsSubHeader')}</H5>
				<P marginTop={'1rem'}>{t('page-settings.ruralInfo')}</P>
			</StyledSettings.HeaderSub>
			{userProfile.preferredDeliveryMethod === LocationType.PackageLabelDecides && (
				<Columns>
					<Column desktopSmall={1 / 3} marginBottom="0">
						<StyledPreferredDeliveryMethod.Card>
							<StyledPreferredDeliveryMethod.CardLink
								onClick={() => dispatch(setActiveModal(DELIVERY_OPTION_MODAL, 'póstbox'))}>
								<StyledPreferredDeliveryMethod.Content>
									<div>
										<StyledPreferredDeliveryMethod.Header>
											<StyledPreferredDeliveryMethod.IconMobile>
												<IconPostbox />
											</StyledPreferredDeliveryMethod.IconMobile>
											<H4>{t('postbox')}</H4>
										</StyledPreferredDeliveryMethod.Header>
										<StyledPreferredDeliveryMethod.Info>
											{t('postboxInfo')}
										</StyledPreferredDeliveryMethod.Info>
									</div>
									<StyledPreferredDeliveryMethod.Select>
										<FaArrowRight />
										<P>{t('choose')}</P>
									</StyledPreferredDeliveryMethod.Select>
								</StyledPreferredDeliveryMethod.Content>
								<StyledPreferredDeliveryMethod.Icon>
									<IconPostbox />
								</StyledPreferredDeliveryMethod.Icon>
							</StyledPreferredDeliveryMethod.CardLink>
						</StyledPreferredDeliveryMethod.Card>
					</Column>
					<Column desktopSmall={1 / 3} marginBottom="0">
						<StyledPreferredDeliveryMethod.Card>
							<StyledPreferredDeliveryMethod.CardLink
								onClick={() => dispatch(setActiveModal(DELIVERY_OPTION_MODAL, 'pakkaport'))}>
								<StyledPreferredDeliveryMethod.Content>
									<div>
										<StyledPreferredDeliveryMethod.Header>
											<StyledPreferredDeliveryMethod.IconMobile>
												<IconPakkaport />
											</StyledPreferredDeliveryMethod.IconMobile>
											<H4>{t('pakkaport')}</H4>
										</StyledPreferredDeliveryMethod.Header>
										<StyledPreferredDeliveryMethod.Info>
											{t('pakkaportInfo')}
										</StyledPreferredDeliveryMethod.Info>
									</div>
									<StyledPreferredDeliveryMethod.Select>
										<FaArrowRight />
										<P>{t('choose')}</P>
									</StyledPreferredDeliveryMethod.Select>
								</StyledPreferredDeliveryMethod.Content>
								<StyledPreferredDeliveryMethod.Icon>
									<IconPakkaport />
								</StyledPreferredDeliveryMethod.Icon>
							</StyledPreferredDeliveryMethod.CardLink>
						</StyledPreferredDeliveryMethod.Card>
					</Column>
					<Column desktopSmall={1 / 3} marginBottom="0">
						<StyledPreferredDeliveryMethod.Card>
							<StyledPreferredDeliveryMethod.CardLink
								onClick={() => dispatch(setActiveModal(DELIVERY_OPTION_MODAL, 'pósthús'))}>
								<StyledPreferredDeliveryMethod.Content>
									<div>
										<StyledPreferredDeliveryMethod.Header>
											<StyledPreferredDeliveryMethod.IconMobile>
												<IconPostoffice />
											</StyledPreferredDeliveryMethod.IconMobile>
											<H4>{t('postoffice')}</H4>
										</StyledPreferredDeliveryMethod.Header>
										<StyledPreferredDeliveryMethod.Info>
											{t('postofficeInfo')}
										</StyledPreferredDeliveryMethod.Info>
									</div>
									<StyledPreferredDeliveryMethod.Select>
										<FaArrowRight />
										<P>{t('choose')}</P>
									</StyledPreferredDeliveryMethod.Select>
								</StyledPreferredDeliveryMethod.Content>
								<StyledPreferredDeliveryMethod.Icon>
									<IconPostoffice />
								</StyledPreferredDeliveryMethod.Icon>
							</StyledPreferredDeliveryMethod.CardLink>
						</StyledPreferredDeliveryMethod.Card>
					</Column>
				</Columns>
			)}
			{userProfile.preferredDeliveryMethod !== LocationType.PackageLabelDecides && locationsLoading && (
				<div style={{ marginTop: '5rem' }}>
					<MyShipmentsTileLoader />
				</div>
			)}
			{locations && userProfile.preferredDeliveryMethod !== LocationType.PackageLabelDecides && (
				<Columns>
					<Column marginBottom="0">
						<StyledSettings.Card>
							<StyledSettings.CardHeader>
								<StyledSettings.IconHeader>
									{deliveryOption.locationType === 'PostOffice' ? (
										<>
											<IconPostoffice />
											<H6>{t('postoffice')}</H6>
										</>
									) : deliveryOption.locationType === 'ParcelPoint' ? (
										<>
											<IconPakkaport />
											<H6>{t('pakkaport')}</H6>
										</>
									) : (
										<>
											<IconPostbox />
											<H6>{t('postbox')}</H6>
										</>
									)}
								</StyledSettings.IconHeader>
								<StyledSettings.LinkGroup>
									<A
										onClick={() =>
											dispatch(
												setActiveModal(
													CONFIRMATION,
													t('page-settings.clearDeliveryOption'),
													'CLEAR_DELIVERYOPTION'
												)
											)
										}>
										<IconBin title={t('page-settings.clearDeliveryOption')} />
										{t('page-settings.clearDeliveryOption')}
									</A>
									<A onClick={() => dispatch(setActiveModal(DELIVERY_OPTION_MODAL, ''))}>
										<IconPencil title={t('change')} />
										{t('change')}
									</A>
								</StyledSettings.LinkGroup>
							</StyledSettings.CardHeader>
							<StyledSettings.UserInfo>
								<StyledSettings.UserInfoItem>
									<P black>{t('page-settings.location')}</P>
									<span>{deliveryOption.name}</span>
								</StyledSettings.UserInfoItem>
								<StyledSettings.UserInfoItem>
									<P black>{t('page-settings.zip')}</P>
									<span>{deliveryOptionAddress.postalCode}</span>
								</StyledSettings.UserInfoItem>
								<StyledSettings.UserInfoItem>
									<P black>{t('page-settings.municipality')}</P>
									<span>{deliveryOptionAddress.city}</span>
								</StyledSettings.UserInfoItem>
								<StyledSettings.UserInfoItem>
									<P black>{t('page-settings.openingHours')}</P>
									<span>{deliveryOption.statusMessage}</span>
								</StyledSettings.UserInfoItem>
							</StyledSettings.UserInfo>
						</StyledSettings.Card>
					</Column>
				</Columns>
			)}
		</>
	);
};

export default PreferredDeliveryMethod;
